var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box-other flex flex-jc-center flex-ai-center"},[_c('p',{staticClass:"footer-text"},[_c('span',[_vm._v(_vm._s(_vm.$t('footer.copy_ltd')))]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v(_vm._s(_vm.$t('footer.icp')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }